module.exports = __webpack_public_path__ + "img/appointment-success.0aee0b75.png";